module.exports = __webpack_public_path__ + "img/sjfx.6fc70577.png";